# frozen_string_literal: true

require_relative 'base'

module Engine
  module Ability
    class SellCompany < Base
    end
  end
end
